import { connect } from 'react-redux';

import { Entities, fetchAll, fetchAllCustomRepository, getEntities, patch, save, search } from 'src/common/index';
import { getOwnCompany } from 'src/selectors/bus-companies';
import { push } from 'react-router-redux';
import FindMyBusOperator from 'src/components/administration/find-my-bus-operator/find-my-bus-operator';
import { fetchCompanyOwnedBookingIntegrations } from 'src/actions/integrations';

const mapStateToProps = state => {
    return {
        busCompany: getOwnCompany(state),
        selectedCompany: state.selectedCompany,
        integration: getEntities(state, Entities.BOOKING_INTEGRATION),
        findMyBusRequests: getEntities(state, Entities.FIND_MY_BUS_REQUEST),
    };
};

const FindMyBusOperatorContainer = connect(mapStateToProps, {
    fetchAll,
    fetchAllCustomRepository,
    fetchCompanyOwnedBookingIntegrations,
    patch,
    search,
    save,
    push,
})(FindMyBusOperator);

export default FindMyBusOperatorContainer;
